import { RefObject } from 'react';

export type MenuAnchor = null | RefObject<HTMLElement | null> | { readonly x: number; readonly y: number };

export function getAnchorProps(anchor: MenuAnchor) {
  if (anchor == null) return {};
  if ('current' in anchor) return { anchorEl: anchor.current };

  return {
    anchorReference: 'anchorPosition' as const,
    anchorPosition: {
      top: anchor.y,
      left: anchor.x,
    },
  };
}
